import React, { Component } from "react";
import { connect } from "react-redux";
import { setAnswer } from "../../../actions/answer";
import { withRouter } from "react-router-dom";
import Slider from "react-slick";
import "./styles.css";
import { AudioRecorder } from "../../../components/AudioRecorder";
import S3FileUpload from "../../../utilities/react-s3/src/ReactS3.js";
import { uploadFile } from "../../../utilities/react-s3/src/ReactS3.js";
import autosize from "autosize";

const config = {
  bucketName: "thrive-web-app",
  dirName: "uploads" /* optional */,
  region: "eu-central-1",
  accessKeyId: "AKIAI4LARSLTVPRMDDDQ",
  secretAccessKey: "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"
};

class QuestionnaireAnswer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showdatalist: [{ 0: "" }],
      answers: {
        0: ""
      },

      photo: null,

      files: [],
      imagePreviewUrl: []
    };

    this.addNewRow = this.addNewRow.bind(this);

    this.handleImageChange = this.handleImageChange.bind(this);
  }

  changeAnswer(key, e) {
    let answersObj = Object.assign({}, this.state.answers);
    answersObj[key] = e.target.value;
    this.setState({ answers: answersObj });
  }



  addNewRow() {
    let newArr = this.state.showdatalist.slice(0);
    newArr.unshift({ key: newArr.length, value: "" });
    this.setState({
      showdatalist: newArr
    });
  }
  removeRow(i) {
    let newArr = [...this.state.showdatalist];
    newArr.splice(i, 1);
    this.setState({ showdatalist: newArr });
  }

  CreateUI(answer) {
    return this.state.showdatalist.map((el, i) => (
      <div key={"data" + i}>
        <div className="form-row">
          <div className="cell-input">
            <div className="textareainput">
              <textarea
                name="answer"
                placeholder="Въведи отговор..."
                value={el.answer}
                onChange={this.onChange.bind(this, i)}
                ref={c => (this.textarea = c)}
                rows={1}
              >
                {this.state.answers[el.key]
                  ? this.state.answers[el.key]
                  : ""}
              </textarea>
            </div>


          </div>

          <div className="cell-bttn">
            <AudioRecorder
              answer={answer}
              setAnswer={this.props.setAnswer}
            />
          </div>

          <div className="cell-bttn-photo">
            <div className="bttn-photo">
              <input
                type="file"
                multiple="true"
                accept="image/*"
                onChange={this.upload}
              />
              {/* onChange={this.handleImageChange}  */}
            </div>
          </div>
        </div>


      </div>
    ))
  }

  componentDidMount() {
    this.textarea.focus();
    autosize(this.textarea);
  }

  handleImageChange(e) {
    e.preventDefault();

    let reader = new FileReader();
    let files = e.target.files;

    reader.onloadend = () => {
      this.setState({
        file: files,
        imagePreviewUrl: reader.result
      });
    };

    reader.readAsDataURL(files);
  }

  upload = e => {
    const { answer, setAnswer } = this.props;
    const batchUpload = [];
    const files = e.target.files;
    for (var i = 0; i < files.length; i++) {
      batchUpload.push(uploadFile(files[i], config));
    }

    Promise.all(batchUpload).then(res => {
      const prevPhotos = answer && answer.photos ? answer.photos : [];
      const updated = answer
        ? {
          answer: {
            ...answer,
            photos: [...prevPhotos, ...res]
          }
        }
        : {
          answer: {
            photos: res
          }
        };
      setAnswer(updated);
    });
  };

  onChange = (i, e) => {
    const { answer, setAnswer } = this.props;
    const { text, value } = e.target;
    let showdatalist = [...this.state.showdatalist]
    showdatalist[i] = { ...showdatalist[i], [text]: value }
    this.setState({ showdatalist });
    setAnswer({
      answer: {
        ...answer,
        answers:
        {
          ...answer.answers,
          [i]: e.target.value,

        }
      }
    });
  };

  onDelete = key => {
    const { answer, setAnswer } = this.props;

    setAnswer({
      answer: {
        ...answer,
        photos: answer.photos.filter(photo => photo.key !== key)
      }
    });
  };

  onDeleteAudio = id => {
    const { answer, setAnswer } = this.props;

    setAnswer({
      answer: {
        ...answer,
        audioFiles: answer.audioFiles.filter(file => file.id !== id)
      }
    });
  };

  render() {
    const { data, answer } = this.props;

    var listImages = {
      dots: false,
      arrows: true,
      infinite: false,
      // variableWidth: true,
      speed: 500,
      cssEase: "ease",
      slidesToShow: 2,
      slidesToScroll: 2,
      autoplay: false,

      responsive: [
        {
          breakpoint: 768,
          settings: {
            infinite: true,
            dots: false,
            arrows: false,
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: false
          }
        }
      ]
    };

    return (
      <div className="content">
        {/* <h4>Въпрос {data.questionNumber}</h4>*/}

        <div
          onClick={() => {
            console.log(this.state);
          }}
          className="title"
        >
          {data.text}
        </div>
        <div className="learn"><p>{data.details}</p></div>
        <div id="display-data-list" className="form">
          {this.CreateUI()}
          {answer && answer.photos && (
            <div className="list-images">
              {answer.photos.map(photo => (
                <div className="img">
                  <div
                    className="bttn-delete"
                    onClick={() => this.onDelete(photo.key)}
                  >
                    <i className="icon-delete" />
                  </div>
                  <img src={photo.location} alt="" />
                </div>
              ))}
            </div>
          )}
          <div className="form-row-add">
            <div className="bttn-add">
              <p className="add-row-bttn" onClick={this.addNewRow.bind(this)}>
                <i className="icon-add" />
                добави поле
              </p>
              <p className="remove-row-bttn" onClick={this.removeRow.bind(this)}>
                <i className="icon-delete" />
                премахни
              </p>
            </div>
            {this.props.answer &&
              this.props.answer.audioFiles &&
              this.props.answer.audioFiles.map(audioFile => (
                <React.Fragment>
                  <div
                    className="bttn-delete-audio"
                    onClick={() => this.onDeleteAudio(audioFile.id)}
                  >
                    <div className="blue-circle"><i className="icon-delete" /></div>
                  </div>
                  <div className="audio">

                    <audio
                      src={audioFile.location}
                      controls="controls"
                    />
                  </div>
                </React.Fragment>
              ))}

          </div>
        </div>
      </div>
    );
  }
}

const mstp = (state, ownProps) => ({
  answer: state.answer.collection[ownProps.match.params.id - 1] || {}
});

const mdtp = (dispatch, ownProps) => ({
  setAnswer: payload =>
    dispatch(
      setAnswer({
        id: +ownProps.match.params.id,
        ...payload
      })
    )
});

export default withRouter(
  connect(
    mstp,
    mdtp
  )(QuestionnaireAnswer)
);



// WEBPACK FOOTER //
// ./src/screens/Questionnaire/QuestionnaireAnswer/QuestionnaireAnswer.js